import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userData: {},
  userStatus: null, 
  userEdit: null,
  loading: false,
  error: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    userSuccess: (state, action) => {
      state.userData = action.payload;
      state.loading = false;
      state.error = null;
    },
    userReset: (state) => {
      state.userData = {};
      state.loading = false;
      state.error = null;
    },
    userLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    userError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setUserStatus: (state, action) => {
      state.userStatus = action.payload;
    },
    setUserEdit: (state, action) => {
      state.userEdit = action.payload;
    },
  },
});

export const { userSuccess, userReset, userLoading, userError, setUserStatus, setUserEdit } =
  userSlice.actions;

export default userSlice.reducer;
